import {FormSubmitHandler, showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {
  useGetMercedesNaSkladeRestPlatformQuery,
  useMercedesNaSkladeRestAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  MercedesNaSkladeAuthenticationFormData,
  PlatformAuthenticationFormMercedesNaSklade,
} from './components/PlatformAuthenticationFormMercedesNaSklade';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';
import {PlatformSettingsPromptBridge} from './PlatformSettingsPromptBridge';

export function PlatformSettingsMercedesNaSkladeRest() {
  return (
    <>
      <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_MERCEDES_NA_SKLADE_PROMPT_BRIDGE}>
        <PlatformSettingsPromptBridge code={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST} />
      </Show>
      <Show whenFeatureDisabled={featureFlags.ADVERTISEMENT_MERCEDES_NA_SKLADE_PROMPT_BRIDGE}>
        <PlatformSettingsMercedesNaSkladeRestLegacy />
      </Show>
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST} />
    </>
  );
}

function PlatformSettingsMercedesNaSkladeRestLegacy() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetMercedesNaSkladeRestPlatformQuery({params});
  const [saveAuthentication] = useMercedesNaSkladeRestAuthenticateMutation();

  const onSubmitCredentials: FormSubmitHandler<MercedesNaSkladeAuthenticationFormData> = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <PlatformAuthenticationFormMercedesNaSklade
      platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST}
      values={data?.credentials}
      isFetching={isFetching}
      isError={isError}
      onSubmit={onSubmitCredentials}
    />
  );
}
